//en environnement de dev -> export const serverUrl = "http://localhost:8080";, sinon ""
export const serverUrl = "";
//URL du projet via l'API GitLab
export const gitExtProjectUrl = "https://gitlab-ext.cantor.fr/api/v4/projects/31";
